import { useMediaQuery } from 'react-responsive';

// DEPRECATED
// Deprecated since this method makes SSR rehydration not work correctly
// https://github.com/yocontra/react-responsive/issues/162
//
// Use utils/MediaQueries.js and pure CSS instead

export const mediaQueries = useMediaQuery;
export const mobileSmallMediaQuery = { query: '(max-width: 330px)' };
export const mobileMediaQuery = { query: '(max-width: 375px)' };
export const smallMediaQuery = { query: '(max-width: 576px)' };
export const tabletMediaQuery = { query: '(max-width: 768px)' };
export const tablethoriMediaQuery = { query: '(max-width: 1024px)' };
export const desktopMediaQuery = { query: '(max-width: 1200px)' };

export const untilMobileMediaQuery = { query: '(max-width: 374px)' };
export const untilSmallMediaQuery = { query: '(max-width: 575px)' };
export const untilTabletMediaQuery = { query: '(max-width: 767px)' };
export const untilTablethoriMediaQuery = { query: '(max-width: 1023px)' };
export const untilDesktopMediaQuery = { query: '(max-width: 1199px)' };

export const fromMobileMediaQuery = { query: '(min-width: 375px)' };
export const fromSmallMediaQuery = { query: '(min-width: 576px)' };
export const fromTabletMediaQuery = { query: '(min-width: 768px)' };
export const fromTablethoriMediaQuery = { query: '(min-width: 1024px)' };
export const fromDesktopMediaQuery = { query: '(min-width: 1200px)' };
